import { normalize } from 'normalizr';
import { query, mutation } from '@/dex-shared/helpers/graphql';
import { examinationBoard } from '@/dex-shared/helpers/normalizr_schema';

export default {
  async PULL_EXAMINATION_BOARDS(
    { commit }: any,
    {
      currentPage,
      resultsPerPage,
    }: { currentPage: number; resultsPerPage: number },
  ) {
    currentPage = currentPage || 0;
    resultsPerPage = resultsPerPage || 50;
    const offset = resultsPerPage * currentPage;
    const response = await query(
      `query pullExaminationBoards($resultsPerPage: Int, $offset: Int){
        allExaminationBoards(first: $resultsPerPage, offset: $offset, orderBy: TITLE_ASC) {
          nodes {
            id
            title
          }
        }
      }`,
      {
        resultsPerPage,
        offset,
      },
    );
    const normalizedResponses = normalize(
      response.data.allExaminationBoards.nodes,
      [examinationBoard],
    );
    commit('CLEAN_STATE', 'examination_boards');
    commit('SET_NORMALIZED_DATA', normalizedResponses.entities);
  },
  async REMOVE_EXAMINATION_BOARD({ commit }: any, examinationBoardId: number) {
    const response = await mutation(
      `mutation dexAdminDeleteExaminationBoardById($examinationBoardId: Int!) {
      deleteExaminationBoardById(input: {
        id: $examinationBoardId
      }) {
        examinationBoard {
          id
        }
      }
    }`,
      { examinationBoardId },
    );
    if (!response.errors) {
      commit('DELETE_ENTITY', {
        entity: 'examination_boards',
        id: examinationBoardId,
      });
    }
  },
};
